import {
  Drawer, List, ListItem, ListItemButton,
  ListItemIcon, ListItemText, Toolbar, Box, Divider
} from '@mui/material'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import GpsFixedIcon from '@mui/icons-material/GpsFixed'
import HomeWorkIcon from '@mui/icons-material/HomeWork'
import FlagIcon from '@mui/icons-material/Flag'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import LogoutIcon from '@mui/icons-material/Logout'
import { useNavigate, useLocation } from 'react-router-dom'  // 👈 เพิ่ม useLocation

import { hasRole, ROLES } from '../utils/roleUtils'

const drawerWidth = 240

export default function Sidebar() {
  const navigate = useNavigate()
  const location = useLocation() // 👈 ตรวจ path ปัจจุบัน
  const role = (localStorage.getItem("role") || "").toLowerCase()

  const allMenus = [
    { text: 'จัดการรถ', icon: <DirectionsCarIcon />, path: '/cars', allow: [ROLES.ADMIN, ROLES.MANAGER, ROLES.INSPECTOR] },
    { text: 'จัดการอุปกรณ์ GPS', icon: <GpsFixedIcon />, path: '/devices', allow: [ROLES.ADMIN, ROLES.MANAGER, ROLES.INSPECTOR] },
    { text: 'จัดการสถานี', icon: <HomeWorkIcon />, path: '/stations', allow: [ROLES.ADMIN, ROLES.INSPECTOR] },
    { text: 'จัดการสถานที่สำคัญ', icon: <FlagIcon />, path: '/landmarks', allow: [ROLES.ADMIN, ROLES.INSPECTOR] },
  ]

  const handleLogout = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("role")
    localStorage.removeItem("roleName")
    navigate("/login")
  }

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
      }}
    >
      <Toolbar />
      <Box display="flex" flexDirection="column" height="100%">
        {/* เมนูหลัก */}
        <List>
          {allMenus
            .filter(item => hasRole(item.allow, role))
            .map((item) => {
              const active = location.pathname.startsWith(item.path) // ✅ ตรวจว่าอยู่ใน path นั้น
              return (
                <ListItem key={item.text} disablePadding>
                  <ListItemButton
                    onClick={() => navigate(item.path)}
                    selected={active} // ✅ ใช้ MUI state
                    sx={{
                      bgcolor: active ? 'primary.main' : 'transparent',
                      color:  active ? 'orange' : 'inherit',
                      fontWeight : active ? 'bold' : 'normal'
                    }}
                  >
                    <ListItemIcon sx={{ color: active ? 'orange' : 'inherit' }}>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItemButton>
                </ListItem>
              )
            })}
        </List>

        <Box flexGrow={1} />
        <Divider />

        {hasRole([ROLES.ADMIN], role) && (
          <List>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => navigate('/setting/users')}
                selected={location.pathname.startsWith('/setting/users')}
                sx={{
                  bgcolor: location.pathname.startsWith('/setting/users') ? 'primary.main' : 'transparent',
                  color: location.pathname.startsWith('/setting/users') ? 'orange' : 'inherit',
                }}
              >
                <ListItemIcon sx={{ color: location.pathname.startsWith('/setting/users') ? 'orange' : 'inherit' }}>
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText primary="จัดการผู้ใช้" />
              </ListItemButton>
            </ListItem>
          </List>
        )}

        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={handleLogout}>
              <ListItemIcon><LogoutIcon /></ListItemIcon>
              <ListItemText primary="ออกจากระบบ" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  )
}
